import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Calendar } from 'lucide-react'
import { GridHookForm } from 'vnetwork-ui'

import { Contract } from '@/modules/Contract/types'

const ContractDatesSection: React.FC = () => {
    const { t } = useTranslation()
    const formControl = useFormContext<Contract>()

    return (
        <div
            data-tour="contract-dates"
            className="border border-green-200 bg-green-50/30 rounded-md overflow-hidden"
        >
            {/* Header */}
            <div className="flex items-center gap-2 p-3">
                <Calendar className="w-4 h-4 text-green-600" />
                <span className="text-sm font-medium text-green-900">
                    {t('contract_duration')}
                </span>
            </div>

            {/* Content */}
            <div className="border-t border-green-200 p-3 bg-white/50">
                <GridHookForm
                    subForm
                    formControl={formControl}
                    actions={[]}
                    className="grid-cols-1 gap-3"
                    data={[
                        {
                            formItemProps: {
                                name: 'contract_effective_date',
                                type: 'datepicker',
                                label: t('contract_effective_date'),
                                placeholder: t('contract_effective_date'),
                            },
                        },
                        {
                            formItemProps: {
                                name: 'contract_expiry_date',
                                type: 'datepicker',
                                label: t('contract_expiry_date'),
                                placeholder: t('contract_expiry_date'),
                            },
                        },
                    ]}
                />
            </div>
        </div>
    )
}

export default ContractDatesSection
